import script from "./Base.vue?vue&type=script&setup=true&lang=js"
export * from "./Base.vue?vue&type=script&setup=true&lang=js"

import "./Base.vue?vue&type=style&index=0&id=31f69ec2&lang=scss"

const __exports__ = script;

export default __exports__